var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpnjTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20529",
    "data-name": "Path 20529",
    d: "M11,21A10,10,0,1,1,21,11,10,10,0,0,1,11,21ZM11,2.333A8.667,8.667,0,1,0,19.667,11,8.667,8.667,0,0,0,11,2.333Z",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20530",
    "data-name": "Path 20530",
    d: "M18.493,17.107l-3.3-3.3A.667.667,0,0,1,15,13.333V8h1.333v5.06l3.107,3.1Z",
    transform: "translate(-4.667 -2.333)",
    fill: "#101820"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpnjTimer);
export default __webpack_public_path__ + "static/media/otpnj-timer.fa337a5065ef2fbdd8f596e9d7f8f726.svg";
export { ForwardRef as ReactComponent };